import { render, staticRenderFns } from "./EquipmentBlock.vue?vue&type=template&id=764fdc0a&scoped=true"
import script from "./EquipmentBlock.vue?vue&type=script&lang=js"
export * from "./EquipmentBlock.vue?vue&type=script&lang=js"
import style0 from "./EquipmentBlock.vue?vue&type=style&index=0&id=764fdc0a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764fdc0a",
  null
  
)

export default component.exports